import { UserLogin, logout, RefreshToken } from '@/api/login'
import { getToken, setToken, removeToken, getNickName, getHeadImg, getMobile, setNickName, setHeadImg, setMobile, setExpTime,getUserType, setUserType } from '@/Utils/auth'
const user = {
  state: {
    token: getToken(),
    nickname: getNickName(),
    headimg: getHeadImg(),
    mobile: getMobile(),
    usertype:getUserType(),
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname
    },
    SET_HEADIMG: (state, headimg) => {
      state.headimg = headimg
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile
    },
    SET_USERTYPE: (state, UserType) => {
      state.usertype = UserType
    },
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const Mobile = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        UserLogin({ Mobile: Mobile, password: userInfo.password }).then(response => {
          const data = response;
          const tokenStr = data.OtherMsg.TokenHead + ' ' + data.OtherMsg.Token;
          setToken(tokenStr);
          setNickName(data.OtherMsg.NickName);
          setHeadImg(data.OtherMsg.HeadImg);
          setMobile(response.OtherMsg.Mobile);
          setUserType(response.OtherMsg.UserType);
          setExpTime((new Date().getTime() / 1000) + Number(data.OtherMsg.ExpTime));
          commit('SET_TOKEN', tokenStr);
          commit('SET_NICKNAME', response.OtherMsg.NickName);
          commit('SET_HEADIMG', response.OtherMsg.HeadImg);
          commit('SET_MOBILE', response.OtherMsg.Mobile);
          commit('SET_USERTYPE', response.OtherMsg.UserType);
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },
    // // 登出
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 刷新Token
    RefreshToken ({ commit }) {
      return new Promise((resolve, reject) => {
        RefreshToken().then(response => {
          const data = response;
          const tokenStr = data.OtherMsg.TokenHead + ' ' + data.OtherMsg.Token;
          setToken(tokenStr);
          setExpTime((new Date().getTime() / 1000) + Number(data.OtherMsg.ExpTime));
          commit('SET_TOKEN', tokenStr);
          resolve((new Date().getTime() / 1000) + Number(data.OtherMsg.ExpTime));
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken();
        localStorage.removeItem("nickName");
        localStorage.removeItem("HeadImg");
        localStorage.clear();
        resolve()
      });
    }
  }
}



export default user
